<template>
  <modal
    title="Create Route Schedule"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >

    <div class="forward-trip mt-3">
      <div>
        <p class="text-primary-yellow font-semibold">Forward Trip</p>
      </div>
      <div class="container-fluid">
        <div class="row gap-0">
          <div class="col-md-12 col-lg-12 col-12">
            <label class="label">Day</label>
            <el-select v-model="schedule.day" placeholder="Select">
              <el-option
                v-for="day in days"
                :key="day"
                :label="day"
                :value="day"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label class="label">Time</label>
           
            <el-time-picker
              value-format="HH:mm:ss"
              v-model="schedule.time"
              placeholder=""
            >
            </el-time-picker>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label class="label">Standard Shipping Time</label>
            <el-select v-model="schedule.sst" placeholder="Select">
              <el-option
                v-for="hour in hours"
                :key="hour"
                :label="hour"
                :value="hour"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label class="label">Express Delivery</label>
            <el-select v-model="schedule.express" placeholder="Select">
              <el-option
                v-for="hour in hours"
                :key="hour"
                :label="hour"
                :value="hour"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="return-trip mt-3">
      <div>
        <p class="text-primary-yellow font-semibold">Return Trip</p>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-12">
            <label class="label">Day</label>
            <el-select v-model="schedule.returnday" placeholder="Select">
              <el-option
                v-for="day in days"
                :key="day"
                :label="day"
                :value="day"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label class="label">Time</label>
            <el-time-picker
              value-format="HH:mm:ss"
              v-model="schedule.returntime"
              placeholder=""
            >
            </el-time-picker>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label class="label">Standard Shipping Time</label>
            <el-select v-model="schedule.returnsst" placeholder="Select">
              <el-option
                v-for="hour in hours"
                :key="hour"
                :label="hour"
                :value="hour"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label class="label">Express Delivery</label>
            <el-select v-model="schedule.returnexpress" placeholder="Select">
              <el-option
                v-for="hour in hours"
                :key="hour"
                :label="hour"
                :value="hour"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="button-wrapper">
      <p class="cursor-pointer" @click="closeModal">
        Cancel
      </p>
      <base-button text="Save" @click="saveRouteSchedule" />
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    editOperation : Boolean,
    editSchedule : Object,
  },
  data() {
    return {
      isGeoTag: "yes",
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      times: [
        "6 AM",
        "7 AM",
        "8 AM",
        "9 AM",
        "10 AM",
        "11 AM",
        "12 PM",
        "1 PM",
        "2 PM",
        "3 PM",
        "4 PM",
        "5 PM",
        "6 PM",
      ],
      hours: [],
      selectedState: "",
      schedule: {
        day: "",
        time: "",
        sst: "",
        express: "",
        returnday: "",
        returntime: "",
        returnsst: "",
        returnexpress: "",
      },
    };
  },
  mounted() {
    this.populateHours();
  },
  updated(){
    this.changeOperation();
  },
  methods: {
    changeOperation(){
        
        if(this.editOperation == true){
            this.schedule = this.editSchedule
        }
    },
    saveRouteSchedule() {
   
      this.$emit("create-schedule", this.schedule, this.editOperation);
      console.log(this.schedule)
      this.closeModal();
    },
    populateHours() {
      for (let i = 1; i < 25; i++) {
        let time = `${i} ${i == 1 ? "Hour" : "Hours"}`;
        this.hours.push(time);
      }
    },
    closeModal() {
      this.$emit("close-modal");
  
      this.schedule = {
        day: "",
        time: "",
        sst: "",
        express: "",
        returnday: "",
        returntime: "",
        returnsst: "",
        returnexpress: "",
      };
    },
  },
  watch: {
    
  },
};
</script>

<style scoped>
.row > div {
  margin-bottom: 1.5rem;
}
.el-date-editor.el-input {
  display: block;
  width: 100%;
}
</style>
